import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { VehicleColorTypeEnum } from '../enums/vehicle-color-type.enum';

/**
 * Vehicle color list DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleColorListDto extends BaseDto {
	name!: string;
	type!: VehicleColorTypeEnum;
	externalReference?: string;

	mobileTitle = (): string | null => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string | null => {
		return `${this.type}`;
	};
}
